import { Box, AspectRatio, AspectRatioProps } from '@chakra-ui/react'
import {
  MUSEUM_BANNER_ASPECT_RATIO,
  MUSEUM_BANNER_ASPECT_RATIO_MOBILE,
} from '../../../lib/const'

interface IHeroAspectRatio extends AspectRatioProps {
  children: JSX.Element
}

const DEFAULT_RATIO = {
  base: MUSEUM_BANNER_ASPECT_RATIO_MOBILE,
  lg: MUSEUM_BANNER_ASPECT_RATIO,
}

const HeroAspectRatio = ({
  children,
  ratio = DEFAULT_RATIO,
  minHeight = 'auto',
  ...rest
}: IHeroAspectRatio) => (
  <AspectRatio
    as="section"
    ratio={ratio}
    minHeight={minHeight}
    sx={{
      '&>*:not(style)': {
        overflow: 'visible',
      },
    }}
    {...rest}
  >
    <Box width="full" height="full">
      {children}
    </Box>
  </AspectRatio>
)

export default HeroAspectRatio
